import {
    get,
    post,
    axios,
} from "../ApiDecorator";

/**
 * 研修平台操作日志（录屏）管理
 * 网关：/course/admin/v2/operationLog
 */
const OperationLog = {
    /** GET 用户+空间聚合列表 */
    getUserList(data) {
        return get("/course/admin/v2/operationLog/userList", data);
    },
    /** GET 某用户在某空间下的录屏明细 */
    getVideos(data) {
        return get("/course/admin/v2/operationLog/videos", data);
    },
    /** GET 本项目已有录屏的空间下拉 */
    getSpaceOptions(data) {
        return get("/course/admin/v2/operationLog/spaceOptions", data);
    },
    /** POST 异步导出 */
    exportAsync(data) {
        return post("/course/admin/v2/operationLog/exportAsync", data);
    },
    /** GET 导出任务状态 */
    getExportStatus(data) {
        return get("/course/admin/v2/operationLog/exportStatus", data);
    },
    /** GET 导出文件（blob） */
    exportDownload(data) {
        const params = { ...data, noCache: new Date().getTime() };
        const query = Object.keys(params)
            .filter((key) => params[key] !== undefined && params[key] !== null && params[key] !== "")
            .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join("&");
        return axios.get(`/course/admin/v2/operationLog/exportDownload?${query}`, {
            responseType: "blob",
        });
    },
};

export default OperationLog;
